import EventIcon from '@mui/icons-material/Event';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import SportsBasketballIcon from '@mui/icons-material/SportsBasketball';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import { Box } from '@mui/material';

export const SportsLiveIcon = () => (
  <Box
    sx={{ width: 24, height: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
  >
    <LiveTvIcon color="error" />
  </Box>
);

export const SportsFuturesIcon = () => (
  <Box
    sx={{ width: 24, height: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
  >
    <EventIcon color="action" />
  </Box>
);

export const SportsBasketBallIcon = () => (
  <Box
    sx={{ width: 24, height: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
  >
    <SportsBasketballIcon />
  </Box>
);

export const SportsSoccerBallIcon = () => (
  <Box
    sx={{ width: 24, height: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
  >
    <SportsSoccerIcon />
  </Box>
);
